<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="国家" prop="country">
                <a-input v-model="queryParam.country" placeholder="请输入国家" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="开始时间" prop="startTime">
                <a-date-picker
                  v-model="queryParam.startTime"
                  placeholder="请选择开始时间"
                  allow-clear
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                />

              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="结束时间" prop="endTime">
                <a-date-picker
                  v-model="queryParam.endTime"
                  placeholder="请选择结束时间"
                  allow-clear
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择订单状态" allow-clear>
                  <a-select-option value="0">待支付</a-select-option>
                  <a-select-option value="1">已支付</a-select-option>
                  <a-select-option value="2">已发货</a-select-option>
                  <a-select-option value="3">已完成</a-select-option>
                  <a-select-option value="4">已售后</a-select-option>
                  <a-select-option value="5">待评价</a-select-option>
                  <a-select-option value="-1">取消订单</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付方式" prop="payType">
                <a-select v-model="queryParam.payType" placeholder="请选择支付方式" allow-clear>
                  <a-select-option value="1">PayPal</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template >




            </template>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>

                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <create-form-detail :orderId="orderId"
        ref="createFormDetail"

      />
      <!-- 上传文件 -->
      <import-excel ref="importExcel" @ok="getList" />
      <finance-form ref="financeForm" @ok="getList" />
<!--      </a-drawer>-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>

        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />-->
          <a @click="$refs.financeForm.handleInfo(record, undefined, queryParam)" v-hasPermi="['order:order:edit']">
            <a-icon type="file" />查看详情
          </a>

        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getStatistics } from '@/api/order/order'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CreateFormDetail from '../orderItem/index'
import ImportExcel from './modules/ImportExcel'
import FinanceForm from "@/views/order/order/modules/FinanceForm";

export default {
  name: 'OrderOrder',
  components: {
    FinanceForm,
    CreateForm,
    CreateFormDetail,
    ImportExcel
  },
  props:["type"],

  mixins: [tableMixin],
  data () {
    return {
      date:[],
      list: [],
      open:false,
      orderId:null,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        country: null,
        startTime: null,
        endTime: null,
        status: null,
        payType: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '国家',
          dataIndex: 'country',
          ellipsis: true,
          align: 'center',
          width:180,
          customRender: (text) => {
            if (text === '')
              return "其他";
            else {
              return text
            }
          }
        },
        {
          title: '订单总数',
          dataIndex: 'orderNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单总金额',
          dataIndex: 'orderAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠总金额',
          dataIndex: 'discountAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '实收总金额',
          dataIndex: 'payAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '已收货订单数',
          dataIndex: 'receiveNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '待收货订单数',
          dataIndex: 'waitReceiveNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }


      ]
    }
  },
  filters: {
  },
  mounted() {
    this.getList()
  },
  // created () {
  //   this.queryParam.userId = this.$route.query.userId
  //   // if (this.$route.query.types)  {
  //   //    this.queryParam.types = this.$route.query.types.split(',')
  //   // }
  //   this.getList()
  // },
  computed: {
  },
  watch: {
  },
  methods: {
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /** 查询订单信息列表 */
    getList () {
      this.loading = true

      getStatistics(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },


    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        country: undefined,
        startTime: undefined,
        endTime: undefined,
        status: undefined,
        payType: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },

  }
}
</script>
